import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class TransformTextService {
  public newName(name: string): string {
    if (name.indexOf('-') >= -1) {
      const nameSplit: string[] = name.split('-');
      const newNameSplit: string[] = [];
      let newName: string;
      for (let i = 0; i < nameSplit.length; i++) {
        newName = this.titleCase(nameSplit[i]);
        newNameSplit.push(newName);
      }
      return newNameSplit.join(' ');
    } else if (name.indexOf('-') === -1) {
      return name.charAt(0).toUpperCase() + name.slice(1);
    }
  }

  private titleCase(string: string): string {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
}
